@if (isReady && allowAttribute) {
  <iframe
    allow="local-network-access *"
    [height]="isMobile ? '100dvh' : '500px'"
    [width]="isMobile ? '100vw' : '100%'"
    frameborder="0"
  #iframeWithAllow></iframe>
}
@if (isReady && !allowAttribute) {
  <iframe
    [height]="isMobile ? '100dvh' : '500px'"
    [width]="isMobile ? '100vw' : '100%'"
    frameborder="0"
  #iframeWithoutAllow></iframe>
}
